import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PerformanceGrowthChart from './PerformanceGrowthChart';
import PerformanceGrowthTable from './PerformanceGrowthTable';
import CalendarPerformanceChart from './PerformanceChart';
import i18next from '../translations/i18n';

const formatDate = dateInput => {
  const date = new Date(dateInput);
  const formatted = date.toLocaleDateString('en-GB'); // "13/08/2024"
  return formatted.replace(/\//g, '-'); // "13-08-2024"
};

const EUPerformanceTabs = ({
  activeTab,
  setActiveTab,
  gro10k,
  tabular,
  historicalPerformanceError,
  entityInceptionDt,
  ucitsFootenote,
}) => (
  <>
    <div className="nav-header">
      <ul className="nav nav-tabs">
        <li className={`tab-responsive ${activeTab === 'graph' ? 'active' : ''}`}>
          <button type="button" className="nav-link" onClick={() => setActiveTab('graph')}>
            {i18next.t('PERFORMANCE_LINE_GRAPH')}
          </button>
        </li>
        <li className={`tab-responsive ${activeTab === 'table' ? 'active' : ''}`}>
          <button type="button" className="nav-link" onClick={() => setActiveTab('table')}>
            {i18next.t('PERFORMANCE_TABLES')}
          </button>
        </li>
      </ul>
    </div>
    <div className="tab-content">
      {activeTab === 'graph' ? (
        <>
          <section className="chart-wrapper">
            <PerformanceGrowthChart />
          </section>
          {gro10k.length > 0 && (
            <section className="calendar-performance-chart m-top">
              <CalendarPerformanceChart />
            </section>
          )}
        </>
      ) : (
        <div className="">
          <PerformanceGrowthTable />
        </div>
      )}
      {tabular.length === 0 && gro10k.length === 0 && historicalPerformanceError && (
        <div className="custom-error-alert">
          <span>{historicalPerformanceError}</span>
        </div>
      )}
      {(activeTab === 'graph' ? gro10k.length > 0 : tabular.length > 0) && (
        <div className="disclosure">
          <p className="disclaimer-text">
            <span>{i18next.t('DISCLAIMER')}</span>
            &nbsp;
            <span>
              {i18next.t('INCEPTION_DATE').replace('{inceptionDt}', formatDate(entityInceptionDt))}
            </span>
          </p>
          <p className="disclaimer-text">
            <span>{ucitsFootenote}</span>
          </p>
        </div>
      )}
    </div>
  </>
);

const PerformanceChartContainer = () => {
  const {
    fundName,
    historicalPerformanceData: { tabular = [], gro10k = [] },
    historicalPerformanceError = '',
    entityInceptionDt,
    ucitsFootenote,
  } = useSelector(state => state.app);
  const [activeTab, setActiveTab] = useState('graph');
  const isEURegion = window.performanceChart?.wtRegion !== 'US';

  return (
    <div className="chart-container">
      <h3 className="typ-h3">{i18next.t('PERFORMANCE_TITLE')}</h3>
      <div className="chart-sub-title">{fundName}</div>
      {isEURegion && (
        <EUPerformanceTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          gro10k={gro10k}
          tabular={tabular}
          historicalPerformanceError={historicalPerformanceError}
          ucitsFootenote={ucitsFootenote}
          entityInceptionDt={entityInceptionDt}
        />
      )}
      {!isEURegion && (
        <section className="calendar-performance-chart m-top">
          <CalendarPerformanceChart />
        </section>
      )}
    </div>
  );
};

export default PerformanceChartContainer;
